import { render, staticRenderFns } from "./PrinterDailyUsageComp.vue?vue&type=template&id=28b56ed2&scoped=true"
import script from "./PrinterDailyUsageComp.vue?vue&type=script&lang=js"
export * from "./PrinterDailyUsageComp.vue?vue&type=script&lang=js"
import style0 from "./PrinterDailyUsageComp.vue?vue&type=style&index=0&id=28b56ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b56ed2",
  null
  
)

export default component.exports